import $ from 'jquery';

function toggleShadow() {
  $('.js-topbar').toggleClass('is-not-on-top', $(window).scrollTop() > 0)
}

function initialize() {
  $(window).on('scroll', toggleShadow);
  toggleShadow();

  $('.js-menu-toggle').on('click', function (e) {
    e.preventDefault();
    $('.js-page-layout').toggleClass('is-navigating');
    $(document.body).toggleClass('is-not-scrollable');
  });
}

export default {
  init: initialize
};
